import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "4214ddff-3887-4335-a212-80232a98acc9",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-1-item-1.svg` },
  },
  {
    id: "d1b16fbb-f448-40a9-9fc7-e8e8a510633a",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-1-item-2.svg` },
  },
  {
    id: "3e40547c-6b09-4c57-87bb-98ddaa784878",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-1-item-3.svg` },
  },
  {
    id: "b8b758bd-eec3-4d6a-9b7c-b9e7bd23e4df",
    options: { imageUrl: `${config.ASSETS_URL}/01/12/task/task-1-item-4.svg` },
  },
];

export const task: Task = {
  id: "120a37e7-ad51-4a08-b239-a1a4070b4619",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    groupLabels: ["", "", "", ""],
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "4214ddff-3887-4335-a212-80232a98acc9",
    "b8b758bd-eec3-4d6a-9b7c-b9e7bd23e4df",
    "d1b16fbb-f448-40a9-9fc7-e8e8a510633a",
    "3e40547c-6b09-4c57-87bb-98ddaa784878",
  ],
};
